import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps body in the standardized viewport
 *
 * @param param0
 * @returns
 */
const ContainerComponent: React.FC<ContainerProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`mx-auto container px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
};

export default ContainerComponent;
